import { TaskType } from 'commons/types/enums'

const map: { [key: string]: string } = {
  [TaskType.DOCUMENT_PERIOD_FILE_UPLOAD]: 'Document period file upload',
  [TaskType.METRC_KEYS_SETUP]: 'METRC keys setup',
  [TaskType.BIO_TRACK_KEY_SETUP]: 'BIO track keys setup'
}

export const getTaskTypeLabel = (name: string) => map[name] || name
